import React, { useEffect, useState } from "react";
import styles from "./contact.module.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Link,
  Button,
  FormHelperText,
  InputBase,
} from "@mui/material";
import { Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Head from "next/head";
import Contact_us from "../../components/contact-us-component/Contact-us";
import ContactUs from "../../components/contact-us-component/Contact-us";

export default function Index() {
  return(
    <>
    
    <Head>
      <title>Contact School of Our Divine Infinite Being – Reach Us 24/7</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
      <meta name="keywords" content="School of Our Divine Infinite Being, 24/7 Customer Service, Contact Information."></meta>
      <meta name="description" content="Connect with the School of Our Divine Infinite Being for inquiries about courses, registration, or general questions. Reach out via email or phone, or fill out our contact form. Available 24/7 to assist you!"></meta>

      <meta property="og:title" content="Contact School of Our Divine Infinite Being – Reach Us Anytime"></meta>
      <meta property="og:type" content="website"></meta>
      <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/contact_us_og_img.webp"></meta>
      <meta property="og:image:alt" content="Contact-us"></meta>
      <meta property="og:description" content="Connect with the School of Our Divine Infinite Being for inquiries about courses, registration, or general questions. Reach out via email or phone, or fill out our contact form. Available 24/7 to assist you!"></meta>

      <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/contact_us_og_img.webp"></meta>
      <meta property="twitter:image:alt" content="Contact-us"></meta>
      <meta name="twitter:card" content="summary_large_image"></meta>
      <meta property="twitter:title" content="Contact School of Our Divine Infinite Being – Reach Us Anytime"></meta>
      <meta property="twitter:url" content="https://www.divineinfinitebeing.com/contact-us"></meta>
      <meta property="twitter:description" content="Connect with the School of Our Divine Infinite Being for inquiries about courses, registration, or general questions. Reach out via email or phone, or fill out our contact form. Available 24/7 to assist you!"></meta>

      <meta property="og:image:width" content="1200"></meta>
      <meta property="og:image:height" content="627"></meta>
      <meta property="og:url" content="https://www.divineinfinitebeing.com/contact-us"></meta>
      <link rel="canonical" href="https://www.divineinfinitebeing.com/contact-us" />
 
    </Head>
    
    <ContactUs/>

    </>

  )
}
